import { Translatable } from '@app/types/translatable.type';
import { ChangeRequestTemplateDisplayOptions } from '@app/types/translatables/change-request-template-display.options';
import { ChangeRequest } from '@models/change-requests/change-request.model';
import { Column } from '@table/classes/column.class';
import { CellDisplay } from '@table/enums/cell-display.enum';

export class RequestTypeColumn extends Column {
    title = 'change-requests.logTable.requestType';
    type: CellDisplay = CellDisplay.string;
    property = 'template.name';

    getDisplayPropertyValue(changeRequest: ChangeRequest): Translatable {
        return ChangeRequestTemplateDisplayOptions[changeRequest.template.name] ?? changeRequest.template.name;
    }
}
